
import _ from "lodash";
import { mapActions } from "vuex";
import CadastroRapidoSelect from "@/components/CadastroRapidoSelect.vue";
import CadastroRapidoMixin from "@/modules/Application/mixins/CadastroRapidoMixin";
import { SistemaMixin } from "@/modules/Application";
import { store } from "../../storeOrcamento";

export default {
  name: "app-orcamento-form-objeto-tab",
  components: {
    CadastroRapidoSelect,
  },
  mixins: [SistemaMixin, CadastroRapidoMixin],
  data() {
    return {
      store,
      form: {
        objeto: null,
        identificadores: [],
      },
      objetos: [],
      identificadores: [],
      identificadoresFilled: {},
      criandoObjeto: false,
    };
  },
  computed: {
    isTheCurrentTab() {
      return this.store.currentTab === 1;
    },
  },
  watch: {
    "store.formCliente.id_pessoa": {
      async handler(idPessoa, idPessoaAnterior) {
        if (idPessoaAnterior && idPessoa !== idPessoaAnterior) {
          this.setObjeto(null);
        }
        await this.carregarObjetosCliente(idPessoa);
      },
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 2 && oldValue < newValue) {
        if (!this.form.objeto?.id_objeto) {
          this.$toast.error("Objeto obrigatório!");
          this.store.currentTab = oldValue;
          return;
        }

        if (this.hasRequiredIdentificadorSemValor()) {
          this.$toast.error("Identificador obrigatório não informado!");
          this.store.currentTab = oldValue;
        }
      }
    },
  },
  async created() {
    await this.getDataInit();
  },
  methods: {
    ...mapActions(["setLoading"]),
    ordenarIdentificadores(identificadores) {
      if (typeof identificadores === "string") {
        try {
          identificadores = JSON.parse(identificadores);
        } catch (error) {
          return [];
        }
      }

      if (!Array.isArray(identificadores)) return [];

      return [...identificadores].sort(
        (a, b) =>
          Number(a?.id_identificador || 0) - Number(b?.id_identificador || 0)
      );
    },
    isIdentificadorObrigatorio(identificador) {
      return ![false, 0, "0"].includes(identificador.obrigatorio);
    },
    isValorPreenchido(value) {
      return (
        value !== null && value !== undefined && String(value).trim() !== ""
      );
    },
    placeholderIdentificador(identificador) {
      return this.isIdentificadorObrigatorio(identificador)
        ? ""
        : "Identificador não obrigatório";
    },
    getValorIdentificador(identificadores, descricao) {
      const identificador = identificadores.find(
        (item) => item.descricao === descricao
      );
      return identificador?.value ?? null;
    },
    getIdentificadoresFilled(identificadores) {
      const valores = this.ordenarIdentificadores(identificadores);

      return this.identificadores.reduce(
        (acc, identificador) => ({
          ...acc,
          [identificador.descricao]: this.getValorIdentificador(
            valores,
            identificador.descricao
          ),
        }),
        {}
      );
    },
    buildIdentificadoresPayload() {
      return this.identificadores.reduce((acc, identificador) => {
        const value =
          this.identificadoresFilled[identificador.descricao] ?? null;

        if (
          this.isIdentificadorObrigatorio(identificador) ||
          this.isValorPreenchido(value)
        ) {
          acc.push({
            id_identificador: identificador.id_identificador,
            descricao: identificador.descricao,
            value,
          });
        }

        return acc;
      }, []);
    },
    hasRequiredIdentificadorSemValor() {
      return this.identificadores.some(
        (identificador) =>
          this.isIdentificadorObrigatorio(identificador) &&
          !this.isValorPreenchido(
            this.identificadoresFilled[identificador.descricao]
          )
      );
    },
    normalizarObjeto(objeto) {
      if (!objeto) return null;

      return {
        ...objeto,
        identificadores: this.ordenarIdentificadores(objeto.identificadores),
      };
    },
    setObjeto(objeto) {
      const objetoNormalizado = this.normalizarObjeto(objeto);
      this.form.objeto = objetoNormalizado;
      this.identificadoresFilled = this.getIdentificadoresFilled(
        objetoNormalizado?.identificadores || []
      );
      this.sincronizarStore();
    },
    changeValue(descricao, value) {
      this.$set(this.identificadoresFilled, descricao, value);
      this.sincronizarStore();
    },
    sincronizarStore() {
      this.form.identificadores = this.buildIdentificadoresPayload();
      this.store.formObjeto = {
        objeto: this.form.objeto,
        identificadores: this.form.identificadores,
      };
    },
    async carregarObjetosCliente(idPessoa) {
      if (!idPessoa) {
        this.objetos = [];
        return;
      }

      try {
        const { data } = await this.$http.post("/objeto/get-objeto", {
          pessoa: idPessoa,
        });
        this.objetos = (data || []).map(this.normalizarObjeto);

        if (!this.form.objeto && this.objetos.length === 1) {
          this.setObjeto(this.objetos[0]);
        }
      } catch (error) {
        this.objetos = [];
      }
    },
    onSearchObjeto(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchObjeto(loading, search, this);
      }
    },
    searchObjeto: _.debounce(async (loading, search, vm) => {
      try {
        const data = await vm.getObjeto(search);
        vm.objetos = (data || []).map(vm.normalizarObjeto);
      } finally {
        loading(false);
      }
    }, 350),
    async criarObjetoInline(descricao) {
      if (this.criandoObjeto) return;

      this.criandoObjeto = true;
      try {
        const objeto = await this.criarObjetoCadastroRapido(
          descricao,
          this.store.formCliente?.id_pessoa
        );
        this.objetos = [
          objeto,
          ...this.objetos.filter((item) => item.id_objeto !== objeto.id_objeto),
        ];
        this.setObjeto(objeto);
        this.$toast.success("Objeto criado e selecionado!");
      } catch (error) {
        this.$toast.error(
          this.mensagemErroCadastroRapido(
            error,
            "Não foi possível criar o objeto."
          )
        );
      } finally {
        this.criandoObjeto = false;
      }
    },
    async getDataInit() {
      try {
        const { data } = await this.$http.post(
          "/identificador/get-identificador"
        );
        this.identificadores = this.ordenarIdentificadores(data);

        const orcamento = this.$route.params.orcamentoData;
        if (orcamento?.objeto) {
          this.form.objeto = this.normalizarObjeto(orcamento.objeto);
          this.identificadoresFilled = this.getIdentificadoresFilled(
            orcamento.identificadores || []
          );
          this.sincronizarStore();
        } else {
          this.identificadoresFilled = this.getIdentificadoresFilled([]);
          this.sincronizarStore();
        }

        await this.carregarObjetosCliente(this.store.formCliente?.id_pessoa);
      } catch (error) {
        this.$toast.error("Erro ao carregar objetos e identificadores");
      }
    },
  },
};
